import { MARQUEE_ITEMS } from "@/data/content";

const Row = ({ ariaHidden = false, overlay = false }) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden}>
        {MARQUEE_ITEMS.map((item) => (
            <div key={item} className="flex items-center">
                <span
                    className={`whitespace-nowrap font-serif italic ${
                        overlay ? "px-7 text-xl text-slate-300 sm:text-2xl" : "px-10 text-2xl text-slate-400 sm:text-3xl"
                    }`}
                >
                    {item}
                </span>
                <span className={`h-px ${overlay ? "w-10 bg-slate-500" : "w-16 bg-slate-700"}`} />
            </div>
        ))}
    </div>
);

export const Marquee = ({ overlay = false }) => (
    <section
        aria-label="Engagement outcomes"
        className={`overflow-hidden ${
            overlay
                ? "border-y border-slate-500/30 py-4"
                : "border-b border-slate-800/70 bg-[#090d14] pb-8 pt-24 sm:pt-28"
        }`}
    >
        <div className="animate-marquee flex w-max">
            <Row overlay={overlay} />
            <Row overlay={overlay} ariaHidden />
        </div>
    </section>
);
